// @ts-ignore
export const all = (state) => state.all.map((ad: any) => ({
    ...ad,
    validFromParsed: convertDate(ad.validFrom),
    validToParsed: convertDate(ad.validTo),
  }));

/**
 * Converts a dd.mm.YYYY date to a time value
 * @param date
 */
function convertDate(date: string) {
  const dateParts = date.split('.');
  return new Date(parseInt(dateParts[2], 10), parseInt(dateParts[1], 10) - 1, parseInt(dateParts[0], 10)).getTime();
}

// @ts-ignore
export const one = (state) => state.one;
